import type { ButtonHTMLAttributes } from "react";

export type ButtonVariant = "primary" | "ghost" | "tool" | "icon";

/**
 * Ein Button für Editor und Quickview statt fünf hand-gestylter Varianten.
 * `variant` wählt den Look; alle nativen Button-Props werden durchgereicht.
 */
export function Button({
  variant = "ghost",
  type = "button",
  className,
  ...rest
}: ButtonHTMLAttributes<HTMLButtonElement> & { variant?: ButtonVariant }) {
  return (
    <button
      type={type}
      className={`ui-btn ui-btn--${variant}${className ? ` ${className}` : ""}`}
      {...rest}
    />
  );
}
